import { render, staticRenderFns } from "./prog.vue?vue&type=template&id=590db7a8"
import script from "./prog.vue?vue&type=script&lang=js"
export * from "./prog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports